import { render, staticRenderFns } from "./DevDoc.vue?vue&type=template&id=7ed11342&scoped=true"
import script from "./DevDoc.vue?vue&type=script&lang=js"
export * from "./DevDoc.vue?vue&type=script&lang=js"
import style0 from "./DevDoc.vue?vue&type=style&index=0&id=7ed11342&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed11342",
  null
  
)

export default component.exports